export default class DateHelper {

    private static timestampToday: number = DateHelper.initToday();
    private static timestampWeek: number = DateHelper.initWeek();
    private static timestampYear: number = DateHelper.initYear();
    private static days = {
        "sk": ["Ne", "Po", "Ut", "St", "Št", "Pi", "So"],
        "cs": ["Ne", "Po", "Út", "St", "Čt", "Pá", "So"],
    };

    private static initToday(): number {
        let date = new Date();
        date.setHours(0, 0, 0);
        return date.getTime();
    }

    private static initWeek(): number {
        let date = new Date();
        date.setHours(12, 0, 0);
        date.setTime(date.getTime() - (6 * 24 * 60 * 60 * 1000));
        date.setHours(0, 0, 0);
        return date.getTime();
    }

    private static initYear(): number {
        let date = new Date();
        date.setHours(0, 0, 0);
        date.setMonth(0, 1);
        return date.getTime();
    }

    public static format(timestamp: number, locale: string): string {

        if (!timestamp) {
            return "";
        }

        timestamp = timestamp * 1000;

        const date = new Date(timestamp);

        if (timestamp >= DateHelper.timestampToday) {
            return DateHelper.formatTime(date);
        }

        if (timestamp >= DateHelper.timestampWeek) {
            return DateHelper.formatWeek(date, locale);
        }

        if (timestamp >= DateHelper.timestampYear) {
            return DateHelper.formatYear(date);
        }

        return DateHelper.formatFull(date);

    }

    private static formatTime(date: Date): string {
        return `${date.getHours()}:${date.getMinutes() < 10 ? "0" : ""}${date.getMinutes()}`;
    }

    private static formatWeek(date: Date, locale: string): string {
        if (DateHelper.days[locale]) {
            return DateHelper.days[locale][date.getDay()] + " " + DateHelper.formatTime(date);
        } else {
            return DateHelper.days["sk"][date.getDay()] + " " + DateHelper.formatTime(date);
        }
    }

    private static formatYear(date: Date): string {
        return `${date.getDate()}. ${date.getMonth() + 1}. ${DateHelper.formatTime(date)}`;
    }

    private static formatFull(date: Date): string {
        return `${date.getDate()}. ${date.getMonth() + 1}. ${date.getFullYear()} ${DateHelper.formatTime(date)}`;
    }

}